import { render } from "./AllVotesModal.vue?vue&type=template&id=4f400a67&scoped=true&ts=true"
import script from "./AllVotesModal.vue?vue&type=script&lang=ts"
export * from "./AllVotesModal.vue?vue&type=script&lang=ts"

import "./AllVotesModal.vue?vue&type=style&index=0&id=4f400a67&scoped=true&lang=css"

import exportComponent from "E:\\SLG\\ECO GAME\\Eco\\Server\\WebClient\\Sources\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f400a67"]])

export default __exports__